// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ce8e168c","455":"b02a01bd","977":"d4a63dfb"}[chunkId] + ".chunk.js";
};